export default [
  {
    path: '/case',
    component: () => import('@views/case'),
    children: (pre => [
      {
        path: pre,
        component: () => import('@views/case/caseIndex'),
        name: 'caseIndex',
        meta: {
          isLogin: false,
          isFooterShow: true,
          title : '案例库'
        }
      },
      {
        path: pre + '/caseDetail',
        component: () => import('@views/case/caseDetail'),
        name: 'caseDetail',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '精选详情'
        }
      },
      {
        path: pre + '/caseSearch',
        component: () => import('@views/case/caseSearch'),
        name: 'caseSearch',
        meta: {
          isLogin: false,
          isFooterShow: false,
          title : '搜索案例'
        }
      }
    ])('/case')
  }
]
